module.exports = __webpack_public_path__ + "static/img/P1_side_right2.6e4b470.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/UST/P1_side_right2.png
// module id = Dlnh
// module chunks = 3